<template>
    <label>{{ label }}
        <input type="radio" :checked="checked" :value="value" :id="'abi-'+name" :disabled="disabled" :name="name">
        <span class="checkmark"></span>
    </label>
</template>
<script>
export default {
    props: [
        "label",
        "checked",
        "disabled",
        "value",
        "name",
    ]
}
</script>
<style scoped src="./Radio.css">
</style>